import React, {useState} from "react";
import {Box, Container, TextField} from "@mui/material";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import {useNavigate} from "react-router-dom";
import {API_BASE_URL} from "./SignUp";

const Login: React.FC<{ onLogin: () => void }> = ({ onLogin }) => {
    const [accountId, setAccountId] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate()

    const handleLogin = async () => {
        if (!accountId || !password) {
            window.alert('모든 값은 필수 항목 입니다.');
            return;
        }

        const loginData = {
            accountId,
            password,
            role: 'USER' // TODO: 유저 권한으로 로그인 잘 되는지 확인하기
        };

        try {
            const response = await fetch(`${API_BASE_URL}/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(loginData),
            });

            if (!response.ok){
                // TODO: 실패 원인 띄울 수 있음 좋을 듯.
                throw new Error('로그인 실패');
            }

            const { accessToken, username } = await response.json();
            localStorage.setItem('accessToken', accessToken);
            localStorage.setItem('username', username)

            onLogin();
        } catch (error) {
            window.alert('로그인 실패')
        }
    };

    return (
        <>
            <Container maxWidth="xs">
                <Box component="form" noValidate autoComplete="off">
                    <TextField
                        label="아이디"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        required
                        value={accountId}
                        onChange={(e) => setAccountId(e.target.value)}
                    />
                    <TextField
                        label="비밀번호"
                        variant="outlined"
                        type="password"
                        fullWidth
                        margin="normal"
                        required
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    {/*TODO: 로그인 버튼 이미지 받은 걸로 바꾸기*/}
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        onClick={handleLogin}
                    >
                        로그인
                    </Button>
                </Box>
            </Container>
        </>
    );
}

export default Login